<div class="left-side">
    <div class="side-nav-header">
        <p class="title">Dashboard</p>
    </div>
    <ul class="navigation">

        <li *ngFor="let item of navItems" [routerLink]="[item.link]" class="nav-item"
            [ngClass]="{'nav-item-active': item.selected === true }" (click)="changeTab(item)">
            <a class="nav-link">{{item.title}}</a>
        </li>
        
    </ul>
</div>